import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { Phone } from 'lucide-react';
import MagneticButton from './MagneticButton';

export default function Navbar() {
    const navRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.to(navRef.current, {
                scrollTrigger: {
                    trigger: "body",
                    start: "top -50",
                    end: "top -100",
                    scrub: true,
                    toggleActions: "play none none reverse",
                },
                backgroundColor: "rgba(244, 244, 245, 0.9)", // solid light background (#F4F4F5)
                backdropFilter: "blur(24px)",
                color: "#111111", // switch text to dark
                border: "1px solid rgba(17, 17, 17, 0.1)",
                paddingTop: "0.75rem",
                paddingBottom: "0.75rem",
            });
        }, navRef);
        return () => ctx.revert();
    }, []);

    return (
        <div className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none">
            <nav
                ref={navRef}
                className="pointer-events-auto flex items-center justify-between w-full max-w-5xl rounded-[3rem] px-6 py-4 text-[#F8F8F8] bg-transparent transition-all duration-300 border border-transparent"
            >
                <div className="text-xl font-heading font-bold uppercase tracking-widest cursor-pointer interactive-link">
                    TOBMAR
                </div>

                <div className="hidden md:flex items-center space-x-8 text-sm font-mono uppercase tracking-wide">
                    <a href="#oferta" className="interactive-link hover:text-accent transition-colors">Oferta</a>
                    <a href="#dlaczego-my" className="interactive-link hover:text-accent transition-colors">Dlaczego My</a>
                    <a href="#proces" className="interactive-link hover:text-accent transition-colors">Proces</a>
                </div>

                <div className="flex items-center gap-6">
                    <a href="tel:+48786148469" className="hidden lg:flex items-center gap-2 font-heading font-black text-lg tracking-widest hover:text-accent transition-colors" style={{ color: 'inherit' }}>
                        <Phone size={18} strokeWidth={2.5} className="text-accent" />
                        +48 786 148 469
                    </a>
                    <MagneticButton href="#kontakt" className="inline-block bg-accent text-background px-6 py-2.5 rounded-full font-heading font-bold uppercase text-sm tracking-wide">
                        Bezpłatna wycena
                    </MagneticButton>
                </div>
            </nav>
        </div>
    );
}
